export default function ComparisonSection() {
  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="mb-14">
          <span className="text-xs font-body text-foreground-500 tracking-widest uppercase">Why Hipobuy Spreadsheet?</span>
          <h2 className="mt-3 text-3xl md:text-5xl font-bold text-foreground-950 font-heading leading-tight">
            Normal Search <span className="italic font-normal text-accent-500">vs</span> Hipobuy<br />Spreadsheet
          </h2>
          <p className="mt-4 text-sm text-foreground-600 font-body max-w-lg">
            Hipobuy Spreadsheet helps shoppers discover organized product information faster. Instead of searching through thousands of pages manually, access structured product databases and research tools.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="text-left py-4 px-6 text-sm font-semibold text-foreground-700 font-body border-b border-background-200">Feature</th>
                <th className="text-left py-4 px-6 text-sm font-semibold text-foreground-400 font-body border-b border-background-200 line-through">Normal Search</th>
                <th className="text-left py-4 px-6 text-sm font-semibold text-accent-600 font-body border-b border-background-200 bg-accent-50/50 rounded-t-lg">
                  <i className="ri-star-fill text-accent-500 mr-1.5"></i>
                  Hipobuy Spreadsheet
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-100">
                <td className="py-4 px-6 text-sm text-foreground-700 font-body">Product Discovery</td>
                <td className="py-4 px-6 text-sm text-foreground-500 font-body">Slow</td>
                <td className="py-4 px-6 text-sm text-accent-700 font-semibold font-body bg-accent-50/30">
                  <i className="ri-flashlight-fill text-accent-500 mr-1.5"></i>
                  Fast
                </td>
              </tr>
              <tr className="border-b border-background-100">
                <td className="py-4 px-6 text-sm text-foreground-700 font-body">Organization</td>
                <td className="py-4 px-6 text-sm text-foreground-500 font-body">Poor</td>
                <td className="py-4 px-6 text-sm text-accent-700 font-semibold font-body bg-accent-50/30">
                  <i className="ri-stack-fill text-accent-500 mr-1.5"></i>
                  Structured
                </td>
              </tr>
              <tr className="border-b border-background-100">
                <td className="py-4 px-6 text-sm text-foreground-700 font-body">Categories</td>
                <td className="py-4 px-6 text-sm text-foreground-500 font-body">Limited</td>
                <td className="py-4 px-6 text-sm text-accent-700 font-semibold font-body bg-accent-50/30">
                  <i className="ri-grid-fill text-accent-500 mr-1.5"></i>
                  Multiple Categories
                </td>
              </tr>
              <tr className="border-b border-background-100">
                <td className="py-4 px-6 text-sm text-foreground-700 font-body">Research Time</td>
                <td className="py-4 px-6 text-sm text-foreground-500 font-body">Hours</td>
                <td className="py-4 px-6 text-sm text-accent-700 font-semibold font-body bg-accent-50/30">
                  <i className="ri-time-fill text-accent-500 mr-1.5"></i>
                  Minutes
                </td>
              </tr>
              <tr>
                <td className="py-4 px-6 text-sm text-foreground-700 font-body">Product Comparison</td>
                <td className="py-4 px-6 text-sm text-foreground-500 font-body">Difficult</td>
                <td className="py-4 px-6 text-sm text-accent-700 font-semibold font-body bg-accent-50/30">
                  <i className="ri-scales-3-fill text-accent-500 mr-1.5"></i>
                  Easy
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-5 mt-12">
          {[
            { step: '01', title: 'Discover Products', desc: 'Find products through organized spreadsheet categories with verified listings.' },
            { step: '02', title: 'Compare Options', desc: 'Analyze price, quality, seller information, and community reviews side by side.' },
            { step: '03', title: 'Review QC Info', desc: 'Understand product quality through detailed QC photos before purchasing.' },
            { step: '04', title: 'Make Decisions', desc: 'Use research-based information to make confident purchase decisions.' },
          ].map((item) => (
            <div key={item.step} className="bg-background-50 rounded-2xl p-6 border border-background-200">
              <span className="text-4xl font-bold text-accent-300 font-heading">{item.step}</span>
              <h4 className="mt-3 text-base font-semibold text-foreground-900 font-body">{item.title}</h4>
              <p className="mt-2 text-sm text-foreground-600 font-body leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}